import React from 'react';
import { useFormContext, get } from 'react-hook-form';
import { GroupSearchSelect } from '../GroupSearchSelect';

interface Props {
  name: string;
  label: string;
  placeholder: string;
  includeAll: boolean;
  groupRegistrationCodes?: string[];
  initialSearchTerm?: string;
}

export function GroupSearchSelectRhf({ name, ...props }: Props) {
  const {
    setValue,
    getValues,
    formState: { errors }
  } = useFormContext();
  const handleSearchTermChange = (v) => setValue('groupSearchTerm', v);
  const handleSelect = (data) => setValue(name, data);
  const error = get(errors, name);

  return (
    <GroupSearchSelect
      {...props}
      onSearchChange={handleSearchTermChange}
      value={getValues(name)}
      onSelect={handleSelect}
      requiredPerm="MemberRead"
      isError={!!error}
      error={error?.message}
    />
  );
}
